import { memo, FC } from 'react';
import classes from './Point.module.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
  point?: string;
  classes?: {
    root?: string;
  };
}


export const Point3_1: FC<Props> = memo(function Point3_1(props) {
  const { t } = useTranslation();

  return (
    <div className={classes.slideContent}>
    <div className={classes.questionBlock}>
      <h4 className={classes.questionTitle}>{t('about:point.03.part1.questionTitle01')}</h4>
      <div className={`${classes.questionAnswer} ${classes.per93}`}>93%</div>
    </div>
    <div className={classes.questionBlock}>
      <h4 className={classes.questionTitle}>{t('about:point.03.part1.questionTitle02')}</h4>
      <div className={`${classes.questionAnswer} ${classes.per79}`}>79%</div>
      <ul className={classes.colorList}>
        <li className={`${classes.colorItem} ${classes.yes}`}>{t('about:point.03.part1.yes')}</li>
        <li className={`${classes.colorItem} ${classes.no}`}>{t('about:point.03.part1.no')}</li>
      </ul>
    </div>
    <small>{t('about:point.03.part1.amendment')}</small>
  </div>
  
  );
});

